import * as Yup from "yup";

const ComapnyValuesSchema = Yup.object().shape({
  values: Yup.string().required("Company Values are required"),
});

export default ComapnyValuesSchema;
